import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return (
    <ul className="hidden w-full lg:items-center gap-[3px] xl:gap-[25px] lg:justify-end lg:flex">
      <HeaderMenu />
    </ul>
  )
}
